import request from "@/utils/request"
import myStore from "@/store/store";

export function login (data) {
    return request({
        url:'/token/login',
        method: "post",
        data:data
    })
}

export function logout (data) {
    return request({
        url:'/token/logout',
        method: "post",
        data:data
    })
}

export function getLoginWay(params){
    return request({
        url: '/token/loginWay',
        method: 'get',
        isToken: true,
        params
    })
}

export function getCode(params){
    return request({
        url: '/token/code',
        method: 'get',
        isToken: true,
        params
    })
}

// 获取机构列表
export function getOrgList(params){
    return request({
        url: '/org/list',
        method: 'get',
        params
    })
}

// 获取账套信息
export function getBooksInfo(params){
    return request({
        url: '/books/selectBooksInfo',
        method: 'get',
        params
    })
}

// 创建任务
export function createTask (data) {
    return request({
        url:'/task/create',
        method: "post",
        data:data
    })
}

// log 日志

export function uploadLogs(data){
    return request({
        url:'/logs/save',
        method: "post",
        repeatSubmit: false,
        noShowLoading: true,
        data:{
            terminalNumber: myStore.state.deviceNo,
            ...data
        }
    })
}
// 第二版接口，上传图片完成
export function accomplish (data) {
    return request({
        url:'/v2/accountingInformation/accomplish',
        method: "post",
        noShowLoading: true,
        data:data
    })
}